import "animate.css";
import "./Header.scss";
import "./Dropdown.scss";
import vLogo from "../../assets/v-logo.png";
import React from "react";
import Dropdown from "react-dropdown";
import { useDispatch, useSelector } from "react-redux";
import {
  selectLanguage,
  selectLanguages,
  setValue,
} from "../../../context/contextSlice";
import SeriesSelector from "../SeriesSelector/SeriesSelector";

function Header({ children, className }) {
  const dispatch = useDispatch();
  const language = useSelector(selectLanguage);
  const languages = useSelector(selectLanguages);

  return (
    <div className={"Header" + (className ? ` ${className}` : "")}>
      <div className="line grow">
        <SeriesSelector />
      </div>
      <img className="logo" src={vLogo} alt="V" />
      <div className="line grow align-right">
        <Dropdown
          options={languages}
          onChange={(e) =>
            dispatch(setValue({ path: "user/language", value: e.value }))
          }
          value={language}
          placeholder="Select an option"
        />
      </div>
      {children}
    </div>
  );
}

export default Header;
